import React, { useState } from 'react';
import ReviewForm from './Review';
import { Flex, Space, Typography } from 'antd';
import EmployeesReviewApi from '../../Api/EmployeesReviewApi';
import { toastError, toastSuccess } from '../Toast/ToastComponent';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { FaArrowLeft } from 'react-icons/fa6';

const { Title } = Typography;

const EmployeesReviewComp = ({ reviewData }) => {
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const { authState } = useAuth();

  const handleRevertToManager = async (values) => {
    try {
      setSaving(true);
      const payload = {
        review_id: reviewData?.id,
        hr_review: {
          comments: values?.hr_review?.comments || null,
        },
        status: 'reverted',
        user_id: authState?.id,
        user_role_id: authState?.userRoleID,
      };
      await EmployeesReviewApi.create(payload);
      toastSuccess('Review reverted to manager successfully.');
      navigate('/employees_review');
    } catch (error) {
      console.error('Error reverting to manager:', error);
      toastError(
        error?.response?.data?.message || 'Failed to revert to manager.',
      );
    } finally {
      setSaving(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setSaving(true);
      const payload = {
        review_id: reviewData?.id,
        hr_review: {
          comments: values?.hr_review?.comments || null,
        },
        status: 'Completed',
        user_id: authState?.id,
        user_role_id: authState?.userRoleID,
      };
      await EmployeesReviewApi.create(payload);
      toastSuccess('Review submitted successfully.');
      navigate('/employees_review');
    } catch (error) {
      console.error('Error submitting review:', error);
      toastError(error?.response?.data?.message || 'Failed to submit review.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-fluid px-2 px-md-3">
      <Flex align="center" gap={8} className="mb-3">
        <span
          className={`border px-2 pb-1 cursor-pointer`}
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft size={16} />
        </span>
        <Title level={4} className="text-dark fw-semibold mt-0 mb-1">
          HR Review
        </Title>
      </Flex>
      <ReviewForm
        monthLabel={'HR Review'}
        readOnly={saving}
        value={{
          hr_review: {
            comments: reviewData?.hr_review?.comments || null,
          },
        }}
        onRevertToManager={handleRevertToManager}
        onSubmit={handleSubmit}
      >
        <Space direction="vertical" size="middle" className="w-100">
          <ReviewForm.EmployeeInfoHeader
            employeeName={
              reviewData?.NewUserMaster
                ? `${reviewData?.NewUserMaster?.first_name} ${reviewData?.NewUserMaster?.last_name}`
                : '--'
            }
            department={reviewData?.department_name || '--'}
            manager={reviewData?.department_head_name || '--'}
            reviewMonth={`${reviewData?.month} ${reviewData?.year}`}
          />
          <ReviewForm.EmployeeReviewSummary
            headerTitle="Employee Review Summary"
            summary={{
              totalHours: reviewData?.total_hours || 0,
              projects: reviewData?.projects_worked || 0,
              leaves: reviewData?.total_leaves || 0,
              attendancePct: reviewData?.attendance_percentage || 0,
            }}
            feedback={reviewData?.employee_review?.feedback || []}
            rates={reviewData?.employee_review?.rating || []}
          />
          <ReviewForm.ManagerReviewSummary
            headerTitle="Manager Review Summary"
            managerFeedback={reviewData?.manager_review?.feedback || []}
            rates={reviewData?.manager_review?.rating || []}
            overallRating={reviewData?.manager_review?.over_all_rating || 0}
          />

          <ReviewForm.HRReview
            headerTitle="HR Review"
            commentsLabel="HR Comments"
            commentsPlaceholder="Enter HR comments"
            commentsName={['hr_review', 'comments']}
          />
        </Space>
      </ReviewForm>
    </div>
  );
};

export default EmployeesReviewComp;
